module.exports = __webpack_public_path__ + "img/11.2c7a0c0e.svg";